import config from 'config';

const LOAD = 'horse-racing/meeting-landing-page/LOAD';
const LOAD_SUCCESS = 'horse-racing/meeting-landing-page/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/meeting-landing-page/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        meeting: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.horseRacing
      && globalState.horseRacing.meetingLandingPage
      && globalState.horseRacing.meetingLandingPage.loading;
}

export function load(meetingId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.horseRacing.loadMeetingData}/${meetingId}`)
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/meetingLandingPage.js